import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import 'react';
import { BsLink45Deg } from '@react-icons/all-files/bs/BsLink45Deg';
import { useContextSelector } from 'use-context-selector';
import { useIsInApp, useSnackbar } from '@bucketplace/design-system';
import { EditorPlaceholder } from '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { jsx } from '@emotion/react';
import { useLinkContext, initialLinkContextValue } from '../../contexts/internal/LinkContext.js';
import '../../contexts/internal/StickyContext.js';
import { EditorContext } from '../../contexts/internal/EditorContext.js';

var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ONLY_APP_LINK = ['https://ohou.se/kakao_sync/non-kakao-user'];
function Link(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContextSelector = useContextSelector(EditorContext, function (context) {
      return context.state;
    }),
    editorType = _useContextSelector.editorType;
  var LinkElement = editorType === 'editor' ? EditorLink : NormalLink;
  return jsx(LinkElement, props, children || jsx(EditorPlaceholder, {
    icon: jsx(BsLink45Deg, null),
    message: "\uC544\uC774\uD15C\uC744 \uCD94\uAC00\uD574\uC8FC\uC138\uC694."
  }));
}
function EditorLink(_ref2) {
  var _callbacks$onClick;
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var to = props.to,
    openOption = props.openOption,
    className = props.className,
    style = props.style;
  var _useContextSelector2 = useContextSelector(EditorContext, function (context) {
      return context.state;
    }),
    displayMode = _useContextSelector2.displayMode;
  var isInApp = useIsInApp(location);
  var _useSnackbar = useSnackbar(),
    open = _useSnackbar.open;
  var _useLinkContext = useLinkContext(),
    callbacks = _useLinkContext.callbacks;
  var initialCallback = initialLinkContextValue.callbacks;
  var onClick = (_callbacks$onClick = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onClick) !== null && _callbacks$onClick !== void 0 ? _callbacks$onClick : initialCallback.onClick;
  function handleClick(e) {
    var _window$open;
    e.preventDefault();
    if (displayMode === 'edit') {
      return;
    }
    if (ONLY_APP_LINK.includes(to) && !isInApp) {
      open({
        content: '오늘의집 앱에서 진행해주시기 바랍니다.'
      });
      return;
    }
    if (openOption === 'anchor') {
      onClick === null || onClick === void 0 || onClick(to);
      return;
    }
    (_window$open = window.open(to, '_blank')) === null || _window$open === void 0 || _window$open.focus();
  }
  return jsx(EditorLinkButton, {
    type: "button",
    onClick: handleClick,
    className: className,
    style: style
  }, children);
}
var EditorLinkButton = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e3l8p7n0"
} : {
  target: "e3l8p7n0",
  label: "EditorLinkButton"
})(process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "e0dnmk",
  styles: "cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
function NormalLink(_ref3) {
  var _callbacks$onClick2;
  var children = _ref3.children,
    props = _objectWithoutProperties(_ref3, _excluded3);
  var to = props.to,
    openOption = props.openOption,
    className = props.className,
    style = props.style,
    logData = props.logData;
  var _useLinkContext2 = useLinkContext(),
    element = _useLinkContext2.element,
    callbacks = _useLinkContext2.callbacks;
  var isInApp = useIsInApp(location);
  var _useSnackbar2 = useSnackbar(),
    open = _useSnackbar2.open;
  var InitialElement = initialLinkContextValue.element,
    initialCallback = initialLinkContextValue.callbacks;
  var LinkElement = element !== null && element !== void 0 ? element : InitialElement;
  var _onClick = (_callbacks$onClick2 = callbacks === null || callbacks === void 0 ? void 0 : callbacks.onClick) !== null && _callbacks$onClick2 !== void 0 ? _callbacks$onClick2 : initialCallback.onClick;
  var getLinkProperties = function getLinkProperties() {
    if (ONLY_APP_LINK.includes(to) && !isInApp) {
      return {
        to: to,
        onClick: function onClick(e) {
          e.preventDefault();
          open({
            content: '오늘의집 앱에서 진행해주시기 바랍니다.'
          });
        }
      };
    }
    switch (openOption) {
      case 'newTab':
        return {
          to: to,
          target: '_blank',
          rel: 'noopener noreferrer'
        };
      case 'anchor':
        return {
          to: "#".concat(to),
          onClick: function onClick() {
            return _onClick === null || _onClick === void 0 ? void 0 : _onClick(to);
          }
        };
      case 'sameTab':
      default:
        return {
          to: to
        };
    }
  };
  var linkProperties = getLinkProperties();
  return jsx(LinkElement, _extends({
    className: className,
    style: _objectSpread2(_objectSpread2({}, style), {}, {
      textDecoration: 'none',
      cursor: 'pointer'
    }),
    logData: logData,
    openOption: openOption
  }, linkProperties), children);
}

export { Link };
//# sourceMappingURL=Link.js.map
